import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getMedia } from "actions/agents";
import Input from "components/Elements/Input";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";

const MediaItem = () => {
  const { media_id } = useParams();
  const { activeMedia } = useSelector((state) => state.agents);
  const [media, setMedia] = useState({});
  const [mediaChunks, setMediaChunks] = useState([]);
  const head = ["id", "public_id", "text", "tags", "embedding"];

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getMedia(media_id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (activeMedia) {
      setMedia(activeMedia);
    }
  }, [activeMedia]);

  useEffect(() => {
    //dispatch(clearMedia());

    if (media && media.chunks) {
      setMediaChunks(
        media.chunks.map((c) => {
          const values = [
            c.id,
            c.public_id,
            c.text,
            <>{c.tags ? c.tags.map((e) => e.name).join(", ") : ""}</>,
            `${c.embedding.substring(0, 50)}...`,
          ];
          return values;
        })
      );
    }
    // eslint-disable-next-line
  }, [media]);

  console.log("MEDIA ID: ", media_id);
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    console.log("STATE: ", location);
  }, [location]);

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="relative p-6 flex-auto ">
              <div>
                <a href={`/admin/agent/${media.agent_id}`}>
                  <i className="fa fa-arrow-left" /> Back to {media.agent}
                </a>{" "}
              </div>
              <h3 className="font-bold text-lg text-blueGray-700">{`${media.name ?? ""
                }`}</h3>
              <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                <label>ID</label>
                <Input
                  label="ID"
                  placeholder="ID"
                  name="id"
                  value={media.id ?? ""}
                  disabled
                />
                <label>Public ID</label>
                <Input
                  label="Public ID"
                  placeholder="Public ID"
                  name="public_id"
                  value={media.public_id ?? ""}
                  disabled
                />
                <label>Name</label>
                <Input
                  label="Name"
                  placeholder="Name"
                  name="name"
                  value={media.name ?? ""}
                  disabled
                />
                <label>Token Count</label>
                <Input
                  label="Token Count"
                  placeholder="Token Count"
                  name="token_count"
                  value={media.token_count ?? "Unknown"}
                  disabled
                />
                <label>Path</label>
                <Input
                  label="Path"
                  placeholder="Path"
                  name="path"
                  value={media.fullpath ?? ""}
                  disabled
                />
                <label>Type</label>
                <Input
                  label="Type"
                  placeholder="Type"
                  name="type"
                  value={media.media_type ?? ""}
                  disabled
                />
                <label>Description</label>
                <Input
                  type="textarea"
                  label="Description"
                  placeholder="Description"
                  name="description"
                  value={media.description ?? ""}
                  disabled
                />
                <label>Tags</label>
                <Input
                  type="textarea"
                  label="Tags"
                  placeholder="Tags"
                  name="tags"
                  value={
                    media.tags ? media.tags.map((e) => e.name).join(", ") : ""
                  }
                  disabled
                />
                <label>Summary</label>
                <Input
                  type="textarea"
                  label="Summary"
                  placeholder="Summary"
                  name="summary"
                  value={media.summary ?? ""}
                  disabled
                  style={{ minHeight: "140px" }}
                />
                <label>Full Text</label>
                <Input
                  type="textarea"
                  label="FullText"
                  placeholder="Full Text"
                  name="Full Text"
                  value={media.fulltext ?? ""}
                  disabled
                  style={{ minHeight: "250px" }}
                />
              </div>
            </div>

            <div className="w-full px-4">
              <CardFullTable
                title="Media Chunks"
                head={head}
                body={mediaChunks}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaItem;
